// extracted by mini-css-extract-plugin
module.exports = {"dpu-new1":"NEW1_dpu-new1__yArhW"};